/**
 * Merge multiple React refs together
 * @returns A single ref that will set the same value
 * for all passed refs.
 */
export const mergeRefs = (...refs) => (value) => {
    refs.forEach((ref) => {
        if (!ref) {
            return;
        }
        else if (typeof ref === 'function') {
            ref(value);
        }
        else if (typeof ref === 'object') {
            const obj = ref;
            obj.current = value;
        }
    });
};
